<template>
<layout-crumb :opts="[{label:$route.meta.label}]">
  <section class="task-selector-wrapper">
    <section v-if="showEmptyTaskTip" class="empty-task-tip">
      <div>当前时间没有您的检查任务, 请联系您的公司管理员确认</div>
      <van-button style="width:120px;margin-top:1em;" @click="getTaskList">刷新</van-button>
    </section>
    <section v-else-if="taskList.length > 0" class="site-select-wrapper">
      <ul class="site-selector-list">
        <li
          v-for="task in taskList"
          :key="task.id"
          class="site-selector-item"
          @click="onSiteSelected(task)"
        >
          <div class=" site-select-item-icon">
            <i class="fa fa-university"></i>
          </div>
          <div class="site-selector-item-text">{{task.siteName}}</div>
        </li>
      </ul>
    </section>
  </section>

  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>
</layout-crumb>
</template>

<script>
export default {
  name: 'index',
  routeInfo: {
    label: '站房选择'
  },
  data () {
    return {
      taskList: [],
      showEmptyTaskTip: false,
      overlayVisible: false
    }
  },
  methods: {
    getTaskList () {
      this.overlayVisible = true

      this.$api.TaskSite.getUserTaskList().then(userTaskList => {
        if (userTaskList.length === 0) {
          this.showEmptyTaskTip = true
        } else {
          this.taskList = Object.freeze(userTaskList)
          this.showEmptyTaskTip = false
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onSiteSelected (task) {
      this.goToNextSelector(task, this.taskList.length)
    },
    goToNextSelector (task, taskNum) {
      this.$store.commit('Task/setTask', task)
      this.$store.commit('Task/setTaskNum', taskNum)

      if (task.stage >= 2) {
        return this.$router.push({
          name: 'Grade'
        })
      }

      this.$router.push({
        // name: 'DeviceSelector'
        name: 'SiteInfo'
      })
    }
  },
  created () {
    this.getTaskList()
  }
}
</script>

<style lang="scss" scoped>
.task-selector-wrapper {
  width: 100%;
  height: 100%;

  .empty-task-tip {
    position: absolute;
    font: {
      size: 20px;
      weight: 600;
    };
    top: 50%;
    left: 50%;
    text-align: center;
    white-space: nowrap;
    transform: translate(-50%, -50%);
  }

  .site-select-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;

    .site-selector-list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      overflow: auto;
    }

    .site-selector-item {
      padding: 1rem;
      margin: 0 5rem 2em;
      border: {
        radius: 5px;
      };
      box-shadow: 0 0 16px 4px rgba(0, 0, 0, .15);

      &:active {
        background-color: #EFEFEF;
      }

      .site-select-item-icon {
        font-size: 10rem;
        padding-left: 8px;
        line-height: 1;
        color: rgba(64, 150, 255, .8);
        /*text-shadow: 2px 2px 4px rgba(0, 0, 0, .5);*/
      }

      .site-selector-item-text {
        font-size: 14px;
        height: 2em;
        line-height: 3;
      }
    }
  }
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/01SiteSelector/index.vue